import { Box, PropertyCard } from '@zillow/constellation-10';
import React from 'react';
import PropertyCardPlaceholder from '../../../images/property_card_placeholder.png';
import propertyUtils from '../../../utils/propertyUtils';
import { StyledBackground } from '../StyledComponents';

const PropertyCardPreview = ({ address = '', unit = '' }) => {
  const [street = '', city = '', stateAndZip = ''] = address.split(',');
  const [state = '', zip = ''] = stateAndZip.trim().split(' ');
  const { formattedCityStateZip, formattedCompleteAddress, formattedStreet } = propertyUtils.formatAddress({
    street: street.trim(),
    unit: unit.trim(),
    city: city.trim(),
    state: state.trim(),
    zip: zip.trim(),
  });

  return (
    <StyledBackground>
      <div style={{ maxWidth: '433px' }}>
        <PropertyCard
          badge={<PropertyCard.Badge>New property</PropertyCard.Badge>}
          data={{
            dataArea1: <Box css={{ marginTop: '600', marginLeft: '200' }}>{formattedStreet}</Box>,
            dataArea2: <Box css={{ marginBottom: '600', marginLeft: '200' }}>{formattedCityStateZip}</Box>,
          }}
          photoBody={<PropertyCard.Photo src={PropertyCardPlaceholder} alt="placeholder property image" />}
          saveButton={<PropertyCard.SaveButton />}
        />
      </div>
    </StyledBackground>
  );
};

export default PropertyCardPreview;
